import { useMemo } from 'react';
import { useFinance } from '@/contexts/FinanceContext';
import { computeChannelResult } from './channelResult';
import type { ChannelPeriodFilter, ChannelResultReport } from './types';

function periodBounds({ year, fromMonth, toMonth }: ChannelPeriodFilter) {
  const from = new Date(year, fromMonth - 1, 1, 0, 0, 0, 0);
  const to = new Date(year, toMonth, 0, 23, 59, 59, 999);
  return { from, to };
}

export function useChannelResult(filter: ChannelPeriodFilter): {
  report: ChannelResultReport;
  from: Date;
  to: Date;
} {
  const { transactions, costCenters } = useFinance();

  return useMemo(() => {
    const { from, to } = periodBounds(filter);
    const channels = costCenters.map((cc) => ({ id: cc.id, name: cc.name, color: cc.color }));
    const report = computeChannelResult({ transactions, channels, from, to });
    return { report, from, to };
  }, [transactions, costCenters, filter]);
}
